import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../scss/dashboard/dashSlider.css";
import {
  CarouselControl,
  Carousel,
  CarouselItem,
  CarouselIndicators,
} from "reactstrap";
import Imagen1 from "../../images/dashboardAbogados/Group 7342.svg";
import Imagen2 from "../../images/dashboardAbogados/Group 7344.svg";
import Imagen3 from "../../images/dashboardAbogados/Group 7346.svg";
import Imagen4 from "../../images/dashboardAbogados/Group 7350.svg";
function Inicioslider({ title }) {
  // State for Active index
  const [activeIndex, setActiveIndex] = React.useState(0);

  // State for Animation
  const [animating, setAnimating] = React.useState(false);

  // Sample items for Carousel
  const items = [
    {
      src: Imagen1,
      caption: "Agrega tus datos",
    },
    {
      src: Imagen2,
      caption: "Configuración de Plantilla",
    },
    // {
    //   src: Imagen3,
    //   caption: "Datos para tu pago",
    // },
    {
      src: Imagen4,
      caption: "Sube tu archivo",
    },
  ];

  // Items array length
  const itemLength = items.length - 1;

  // Previous button for Carousel
  const previousButton = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? itemLength : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  // Next button for Carousel
  const nextButton = () => {
    if (animating) return;
    const nextIndex = activeIndex === itemLength ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  // Carousel Item Data
  const carouselItemData = items.map((item) => {
    return (
      <CarouselItem
        key={item.src}
        className="Slider-Item_abogados"
        onExited={() => setAnimating(false)}
        onExiting={() => setAnimating(true)}
      >
        <div className="Slider-Item-div">
          <h6 className="font-weight-bold">
            ¿Como crear <br /> {title}
          </h6>
          <img
            className="slider__foto__dashboardAbogados"
            src={item.src}
            alt={item.altText}
          />
          <p>{item.caption}</p>
        </div>
      </CarouselItem>
    );
  });

  return (
    <div
      style={{
        display: "block",
        width: 300,
        padding: 0,
      }}
    >
      <Carousel
        previous={previousButton}
        next={nextButton}
        activeIndex={activeIndex}
      >
        <CarouselIndicators
          items={items}
          className={"Carousel--dash--indicatos li"}
          activeIndex={activeIndex}
          onClickHandler={(newIndex) => {
            if (animating) return;
            setActiveIndex(newIndex);
          }}
        />
        {carouselItemData}
        <CarouselControl
          directionText="Prev"
          direction="prev"
          className="Carousel--dash"
          onClickHandler={previousButton}
        />
        <CarouselControl
          directionText="Next"
          direction="next"
          className="Carousel--dash"
          onClickHandler={nextButton}
        />
      </Carousel>
    </div>
  );
}

export default Inicioslider;
